import React from 'react';
import { ReviewCaseDetails } from 'pages/components';

const CasesNewReview = (props) => (
  <ReviewCaseDetails {...props} />
);

export default CasesNewReview;
